
const initialState = {
  safes: [],
  totalElements: 0,
  loading: true
};

export function fetchDealerSafes(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_DEALER_SAFES.SUCCESS':
      return {
        ...state,
        safes: action.safes.body.content,
        totalElements: action.safes.body.totalElements,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dealerSafes.js